import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import * as React from 'react';
import { Bracket, Seed, SeedItem, SeedTeam, SeedTime } from 'react-brackets';
import * as Redux from 'react-redux';
import { GREEN_COLOR } from '../../../../../constants/ColorsConst';
import { ModalComponent } from '../../../../../widgets';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { setActivoEquiposJuegosAction } from '../../../equipos_juegos/EquiposJuegosAction';
import { setActivoJuegosAction } from '../../../juegos/JuegosAction';
import FormJuegos from '../../../juegos/components/FormJuegos';

const equipoRender = (data, click) => {
  return (
    data && (
      <Box
        sx={{
          backgroundColor: data.ganador ? GREEN_COLOR : 'white',
          '&:hover': {
            backgroundColor: data.ganador
              ? green[800]
              : 'rgba(255,255,255,0.9)',
            cursor: 'pointer',
            color: data.ganador ? 'white' : 'black',
          },
        }}
        onClick={click}
      >
        <SeedTeam style={{ width: '250px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              width: '100%',
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar
                alt={data.equipo.imagen}
                sx={{ width: 50, height: 50 }}
                src={getFilesArchivos(data.equipo.imagen)}
              />
              <div>
                <Typography
                  sx={{
                    color: data.ganador ? 'white' : 'black',
                    fontWeight: 'bold',
                    fontSize: '10pt',
                  }}
                  align="start"
                >
                  {data?.equipo.nombre || '-'}
                </Typography>

                <Typography
                  sx={{
                    color: data.ganador ? 'white' : 'black',
                    fontSize: '10pt',
                  }}
                  align="start"
                >
                  {data?.equipo?.lider
                    ? `${data?.equipo?.lider?.jugador.perfil.pnombre} ${data?.equipo?.lider?.jugador.perfil.papellido}`
                    : 'Sin Lider'}
                </Typography>
              </div>
            </Stack>

            <Typography
              sx={{
                color: data.ganador ? 'white' : 'black',
                fontWeight: data.ganador ? 'bold' : 'nomral',
                fontSize: data.ganador ? '20pt' : '16pt',
              }}
              textAlign="center"
            >
              {data?.resultado || '0'}
            </Typography>
          </Stack>
        </SeedTeam>
      </Box>
    )
  );
};

const RenderSeed = ({ setOpenForm, breakpoint, seed }) => {
  const dispatch = Redux.useDispatch();

  const juegosStore = Redux.useSelector((state) => state.juegos);
  const juego = juegosStore.all.find((el) => el.id === seed.id);

  return (
    <Seed mobileBreakpoint={breakpoint}>
      <SeedItem style={{ width: '100%' }}>
        <div>
          {equipoRender(juego.equipos[0], () => {
            setActivoEquiposJuegosAction(dispatch, juego.equipos[0]);
            setOpenForm(true);
          })}
          <div style={{ height: 1, backgroundColor: 'black' }}></div>
          {equipoRender(juego.equipos[1], () => {
            setActivoEquiposJuegosAction(dispatch, juego.equipos[1]);
            setOpenForm(true);
          })}
        </div>
      </SeedItem>
      <SeedTime mobileBreakpoint={breakpoint} style={{ fontSize: 9 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 'bold' }}
          color="initial"
        >
          {seed.date}
        </Typography>
      </SeedTime>
    </Seed>
  );
};

const GraficoResultadosComponent = ({
  setOpenForm = () => {},
  isAdd = true,
}) => {
  const dispatch = Redux.useDispatch();

  const rondasStore = Redux.useSelector((state) => state.rondas);
  const juegosStore = Redux.useSelector((state) => state.juegos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  function juegos(idRonda) {
    const data = [];

    juegosStore.all.forEach((el) => {
      if (el.ronda.id === idRonda) {
        const teams = [];
        el.equipos.forEach((team) =>
          teams.push({
            id: team.equipo.id,
            name: team.equipo.nombre,
            score: team.resultado,
          }),
        );

        data.push({
          id: el.id,
          date: el.fechaHora,
          teams,
        });
      }
    });

    return data;
  }

  function rondas() {
    const data = [];

    rondasStore.all.forEach((el) => {
      data.push({
        title: el.nombre,
        seeds: juegos(el.id),
      });
    });

    return data;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        {isAdd && (
          <BotonComponent
            click={async () => {
              await setActivoJuegosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
            ml={2}
            mt={2}
            mb={1}
          />
        )}
      </Grid>
      <Grid item xs={12} md={12} sx={{ p: 1, pb: 2 }}>
        {(!juegosStore.loadingAll || !rondasStore.loadingAll) &&
          juegosStore.all.length > 0 && (
            <Bracket
              mobileBreakpoint={767}
              rounds={rondas()}
              renderSeedComponent={(props) => {
                return RenderSeed({ ...props, setOpenForm });
              }}
              swipeableProps={{ enableMouseEvents: true, animateHeight: true }}
            />
          )}
      </Grid>
      <ModalComponent
        id="modalFormJuegos"
        title={`${
          juegosStore.activo
            ? `Editar ${juegosStore.activo.nombre}`
            : 'Nuevo juego'
        }`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormJuegos
          activo={juegosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default GraficoResultadosComponent;
